import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { authActions, sessionActions } from 'src/app/store/actions';
import { AppState } from '../models/app-state.models';
import { EndpointName } from '../models/endpoints.models';
import { APIService } from './api.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SessionService {
    tokenresult$=new Subject()
    authToken$=new Subject()
    constructor(
        private store: Store<AppState>,
        private apiService: APIService,
        private router:Router
    ) { }

    validateSession() {
        setTimeout(() => {
            if(!this.router.url.includes('admin')){
                //console.warn(this.router.url)
                /* this.apiService.get(EndpointName.login)
                .pipe(take(1))
                .subscribe(r => {
                    this.store.dispatch(authActions.loginSuccess({ data: r.data }))
                }) */
            }
        }, 4000);
        
        
    }

     validateToken(token:any){
       
        
            this.store.dispatch(sessionActions.showAppLoader());
             this.apiService.post(EndpointName.verifyToken, {}).subscribe(response=>{
                this.store.dispatch(sessionActions.hideAppLoader());
                this.tokenresult$.next(response.data)
             },
             (error) => {
               console.error('Error occurred:', error);
               // Handle the error as needed, for example, dispatching an error action
               this.store.dispatch(sessionActions.hideAppLoader());
               this.tokenresult$.next('error')
             })   
          
        }
  

    

    validateLoginBlock() {
        if(localStorage.getItem('login_scope_t')) {
            const blockedTime = localStorage.getItem('login_scope_t')
            const expireTime = moment(blockedTime).add(30, 'minutes').format();
            const currentTime = moment().format();
            if(moment(expireTime).isBefore(currentTime)){
                // create function for the below code
                localStorage.removeItem('login_scope');
                localStorage.removeItem('login_scope_t');
                this.store.dispatch(sessionActions.unblockLogin());
            }else {
                this.store.dispatch(sessionActions.blockLogin());
            }
        }
    }

}